import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHeroSection from './components/ContactHeroSection';
import ContactFormSection from './components/ContactFormSection';
import ContactDetailsSection from './components/ContactDetailsSection';
import { Link } from 'react-router-dom';

export default function Contact() {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'Contact | Tony Monteiro Mortgage Agent';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contact Ontario mortgage agent Tony Monteiro for expert advice. Book an appointment Monday–Friday, 9AM–7PM, for mortgage or refinance consultations across Ontario.');
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'contact Tony Monteiro mortgage agent, book mortgage consultation, trusted mortgage broker Ontario, Waterloo Brant Wellington mortgage help, best mortgage advisor near me Ontario');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://mortgagesforyoubytony.ca/contact');

    // Add JSON-LD schema
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = '{"@context":"https://schema.org","@graph":[{"@type":"ContactPage","url":"https://mortgagesforyoubytony.ca/contact","name":"Contact Tony Monteiro Mortgages","isPartOf":{"@type":"Organization","@id":"https://mortgagesforyoubytony.ca/#org"},"publisher":{"@type":"Organization","@id":"https://mortgagesforyoubytony.ca/#org"}},{"@type":"ContactPoint","telephone":"+1-519-658-3026","email":"tjcmonteiro@rogers.com","contactType":"Customer Service","areaServed":"CA","availableLanguage":["English"]},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://mortgagesforyoubytony.ca/"},{"@type":"ListItem","position":2,"name":"Contact","item":"https://mortgagesforyoubytony.ca/contact"}]}]}';
    document.head.appendChild(schemaScript);
  }, []);

  return (
    <div className="min-h-screen bg-dark-900">
      <Header />
      <main>
        <ContactHeroSection />
        <ContactFormSection />
        
        {/* Refinance Options Link */}
        <section className="py-8 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white rounded-lg shadow-md p-6 max-w-md mx-auto">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Have questions about refinancing?
              </h3>
              <Link
                to="/refinance-options"
                className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold transition-colors whitespace-nowrap"
              >
                Ask about refinancing options
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </section>
        
        <ContactDetailsSection />
      </main>
      <Footer />
    </div>
  );
}